export default class CreateWalletTemplateModalController {

    constructor($uibModalInstance, $scope, $injector) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.translate = this.injector.get('$translate');
        this.alert = this.injector.get('Alert');

        this.model = {
            name: ''
        }
        this.submitting = false;
        this._resetError();
    }

    dismiss() {
        this.uibModalInstance.dismiss();
    }

    submit(form) {
        this._resetError();

        if(!form.$valid) {
            this._setError(this.translate.instant('wallets.templates.modals.create.errors.invalid_data'));
            return;
        }

        this.submitting = true;

        this.api.post('wallets/templates', this.model)
            .then(({data}) => {
                this.uibModalInstance.close({
                    wallet: data.data
                });
            })
            .catch((e) => {
                this.submitting = false;
                this.alert.handle(e);
            });
    }

    _resetError() {
        this.error = {
            active: false,
            message: ''
        }
    }

    _setError(message) {
        this.error = {
            active: true,
            message: message
        }
    }
}

CreateWalletTemplateModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/controllers/modals/create-template-modal.js